import {
  Box,
  Button,
  Checkbox,
  Container,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Link,
} from '@chakra-ui/react'
import NextLink from 'next/link'
import { FC, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useConnectParams } from 'src/connect/useParams'
import { reactHookFormDefaultOptions } from 'src/form/reactHookFormDefaultOptions'
import {
  compose,
  validateEmailPattern,
  validateMaxLength,
  validateRequired,
} from 'src/form/validations'
import { PagePadding } from 'src/layout/PagePadding'
import { PageRoot } from 'src/layout/PageRoot'
import { Footer } from 'src/navigation/Footer'
import IbsLogo from 'src/navigation/Logo/ibs.svg'
import { pagesPath } from 'src/routes/$path'

type FormValues = {
  email: string
  password: string
}

export const IndexIbs: FC<{
  onSubmitEmailLogin: (values: FormValues) => void
  submitting: boolean
}> = ({ onSubmitEmailLogin, submitting }) => {
  const { getUrlQuery } = useConnectParams()
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>({
    ...reactHookFormDefaultOptions,
  })

  const [passwordVisible, setPasswordVisible] = useState<boolean>(false)

  return (
    <PageRoot>
      <Box
        bgColor="green.50"
        minH="272px"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <IbsLogo />
      </Box>
      <Container maxW="centeredRow">
        <form onSubmit={handleSubmit(v => onSubmitEmailLogin(v))}>
          <Box mt="64px">
            <FormControl id="email" isInvalid={!!errors.email}>
              <FormLabel fontWeight="normal" color="gray.800">
                ID/メールアドレス
              </FormLabel>
              <Input
                type="text"
                size="lg"
                placeholder="ID/メールアドレスを入力"
                {...register('email', {
                  ...compose(
                    validateRequired,
                    validateEmailPattern,
                    validateMaxLength(76),
                  )('ID/メールアドレス'),
                })}
              />
              <FormErrorMessage>{errors.email?.message}</FormErrorMessage>
            </FormControl>
            <FormControl id="password" mt={6} isInvalid={!!errors.password}>
              <FormLabel fontWeight="normal" color="gray.800">
                パスワード
              </FormLabel>
              <Input
                type={passwordVisible ? 'text' : 'password'}
                size="lg"
                placeholder="パスワードを入力"
                {...register('password', {
                  ...compose(validateRequired)('パスワード'),
                })}
              />
              <FormErrorMessage>{errors.password?.message}</FormErrorMessage>
            </FormControl>
            <Box mt={4}>
              <Checkbox
                checked={passwordVisible}
                onChange={e => setPasswordVisible(e.target.checked)}
              >
                パスワードを表示する
              </Checkbox>
            </Box>
          </Box>
          <Box mt={6}>
            <Button width="100%" size="lg" fontWeight="bold" type="submit" isLoading={submitting}>
              ログインする
            </Button>
          </Box>
          <Box mt={6} textAlign="center">
            <NextLink href={pagesPath.recovery.email.$url(getUrlQuery())} legacyBehavior>
              <Link fontWeight="bold" color="gray.600">
                パスワードがわからない方はこちら
              </Link>
            </NextLink>
          </Box>
        </form>
      </Container>
      <PagePadding />
      <Footer />
    </PageRoot>
  )
}
